import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MatDialogRef} from '@angular/material';
import {ToastComponent, ToastType} from '../../../vision/toast/toast/toast.component';

@Component({
  selector: 'awair-device-setting-dialog',
  templateUrl: './device-setting-dialog.component.html',
  styleUrls: ['./device-setting-dialog.component.scss']
})

export class DeviceSettingDialogComponent implements OnInit {

  @ViewChild('successToast') successToastComponent: ToastComponent;
  @ViewChild('failToast') failToastComponent: ToastComponent;

  @Input() isLoading: boolean = false;
  @Output() openDeviceNameEditor: EventEmitter<void> = new EventEmitter<void>();
  @Output() showAllLed: EventEmitter<void> = new EventEmitter<void>();
  @Output() hideAllLed: EventEmitter<void> = new EventEmitter<void>();

  ToastType = ToastType;

  constructor(private myDialogRef: MatDialogRef<DeviceSettingDialogComponent>) {
  }

  ngOnInit() {
  }

  requestSuccess(): void {
    this.successToastComponent.show();
  }

  requestError(): void {
    this.failToastComponent.show();
  }

  onEditName(): void {
    this.openDeviceNameEditor.emit();
  }

  onShowAllLed(): void {
    this.showAllLed.emit();
  }

  onHideAllLed(): void {
    this.hideAllLed.emit();
  }

  onClose(): void {
    this.myDialogRef.close();
  }
}
